webpackJsonp([20],{

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_config__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__ = __webpack_require__(68);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
    config: __WEBPACK_IMPORTED_MODULE_3__modules_config__["a" /* default */]
  },
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__["a" /* default */])({
    paths: ['user', 'config']
  })]
}));

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53);
module.exports = __webpack_require__(54);


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_vuetify__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sentry_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mdi_font_css_materialdesignicons_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__mdi_font_css_materialdesignicons_css__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {
    var token = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user.token;
    var userType = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user.userType;

    if (!token || !userType) {
      next({ name: 'login' });
    } else {
      if (to.meta.grants.includes(userType.id)) {
        next();
      } else {
        next({ name: 'ops' });
      }
    }
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_5__sentry_vue__["a" /* init */]({
  Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["default"],
  dsn: 'https://6c0ac96acfff9b32cb318720134e7dfd@o4507741824221184.ingest.us.sentry.io/4507976471937024',
  // integrations: [
  //   Sentry.browserTracingIntegration({ router }),
  //   Sentry.replayIntegration()
  // ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/corretores\.idealizacidades\.com\.br/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Enabled in production environment
  enabled: "production" === 'production'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  vuetify: __WEBPACK_IMPORTED_MODULE_3__plugins_vuetify__["a" /* default */],
  template: '<App/>',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d644ef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(60);
function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d644ef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 58:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_mask__ = __webpack_require__(63);
/* eslint-disable space-before-function-paren */




var AppLayout = function AppLayout() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 117));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 118));
};
var Users = function Users() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 119));
};
var Clients = function Clients() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 120));
};
var SiengeClients = function SiengeClients() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 121));
};
var SiengeCreditors = function SiengeCreditors() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 122));
};
var FormClient = function FormClient() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 123));
};
var RealStates = function RealStates() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 124));
};
var Properties = function Properties() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 125));
};
var SizeLots = function SizeLots() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 126));
};
var Reserves = function Reserves() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 127));
};
var Politics = function Politics() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 128));
};
var MyInfos = function MyInfos() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 129));
};
var Ops = function Ops() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 130));
};
var Configs = function Configs() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 131));
};
var Professions = function Professions() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 132));
};
var Requests = function Requests() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 133));
};
var Dashboards = function Dashboards() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 134));
};
var ClientChanges = function ClientChanges() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 135));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('mask', __WEBPACK_IMPORTED_MODULE_2_v_mask__["a" /* VueMaskDirective */]);

var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var adminRole = [1];
var adminOrManagerRole = [1, 3];
var collaboratorRole = [1, 2, 3];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/politicas-de-privacidade',
    name: 'politics',
    component: Politics
  }, {
    path: '/ops',
    name: 'ops',
    component: Ops
  }, {
    path: '',
    component: AppLayout,
    children: [{
      path: '/',
      name: 'clients',
      component: Clients,
      meta: {
        requireAuth: true,
        grants: collaboratorRole
      }
    }, {
      path: '/graficos',
      name: 'dashboards',
      component: Dashboards,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/clientes-sienge',
      name: 'sienge-clients',
      component: SiengeClients,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/clientes/novo',
      name: 'createClient',
      component: FormClient,
      meta: {
        requireAuth: true,
        grants: collaboratorRole
      }
    }, {
      path: '/clientes/:id/editar',
      name: 'editClient',
      component: FormClient,
      meta: {
        requireAuth: true,
        grants: collaboratorRole
      }
    }, {
      path: '/usuarios',
      name: 'users',
      component: Users,
      meta: {
        requireAuth: true,
        grants: adminOrManagerRole
      }
    }, {
      path: '/credores',
      name: 'sienge-creditors',
      component: SiengeCreditors,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/imobiliarias',
      name: 'realStates',
      component: RealStates,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/imoveis',
      name: 'properties',
      component: Properties,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/tamanhos',
      name: 'sizeLots',
      component: SizeLots,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/reservas',
      name: 'reserves',
      component: Reserves,
      meta: {
        requireAuth: true,
        grants: collaboratorRole
      }
    }, {
      path: '/solicitacoes',
      name: 'requests',
      component: Requests,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/infos',
      name: 'myinfos',
      component: MyInfos,
      meta: {
        requireAuth: true,
        grants: collaboratorRole
      }
    }, {
      path: '/configuracoes',
      name: 'configs',
      component: Configs,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/profissoes',
      name: 'professions',
      component: Professions,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }, {
      path: '/clientes-alterados',
      name: 'client-changes',
      component: ClientChanges,
      meta: {
        requireAuth: true,
        grants: adminRole
      }
    }]
  }, { path: '*', component: Ops }]
}));

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  id: null,
  token: null,
  userType: null,
  broker: null,
  realState: null
};

var mutations = {
  setToken: function setToken(state, token) {
    state.token = token;
  },
  setUserType: function setUserType(state, userType) {
    state.userType = userType;
  },
  setBroker: function setBroker(state, broker) {
    state.broker = broker;
  },
  setRealState: function setRealState(state, realState) {
    state.realState = realState;
  },
  setId: function setId(state, id) {
    state.id = id;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  showMenuReserves: null,
  syncSienge: null,
  docObrigatory: null,
  conjugateData: null
};

var mutations = {
  setShowMenuReserve: function setShowMenuReserve(state, payload) {
    state.showMenuReserves = payload;
  },
  setSyncSienge: function setSyncSienge(state, payload) {
    state.syncSienge = payload;
  },
  setDocObrigatory: function setDocObrigatory(state, payload) {
    state.docObrigatory = payload;
  },
  setConjugateData: function setConjugateData(state, payload) {
    state.conjugateData = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
var user = function user(state) {
  return state.user;
};
var config = function config(state) {
  return state.config;
};



/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a({
  theme: {
    themes: {
      light: {
        primary: '#8cbe30',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
}));

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[52]);


// WEBPACK FOOTER //
// static/js/app.639065f3463a44a4c8dc.js